import { render, staticRenderFns } from "./goDashboard.vue?vue&type=template&id=55be41b6&scoped=true"
import script from "./goDashboard.vue?vue&type=script&lang=js"
export * from "./goDashboard.vue?vue&type=script&lang=js"
import style0 from "./goDashboard.vue?vue&type=style&index=0&id=55be41b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be41b6",
  null
  
)

export default component.exports